/**
 * Shared header/drawer nav items (role + showMenu branches), so Accountant and Company Dashboard stay in sync.
 * Item shape: { id, label?, intlId?, to?, children? }
 */
export function getNavMenuItems(user) {
    if (!user) {
        return [];
    }

    const role = user.role;
    const show = user.showMenu || false;
    const companyId = user.companyId;

    if (role == 'Contact' && show == false) {
        return [
            { id: 'home', label: 'Home', to: '/dashboard' },
            {
                id: 'reports',
                intlId: 'sidebar.reports',
                children: [
                    { id: 'reportReview', intlId: 'sidebar.accoutant.review', to: '/reportReview' },
                    { id: 'taxableReview', intlId: 'sidebar.accoutant.taxable', to: '/taxableReview' }
                ]
            }
        ];
    }

    if (role == 'Accountant' && show == false) {
        return [
            { id: 'home', label: 'Home', to: '/home' }
        ];
    }

    if (show == false && (role == 'SuperAdmin' || role == 'Admin')) {
        const items = [
            { id: 'home', label: 'Home', to: '/home' },
            { id: 'companies', label: 'Companies', to: '/companies' },
            { id: 'assigned', label: 'Assigned Companies', to: '/accountant' },
            { id: 'users', label: 'Users', to: '/users/0' }
        ];

        if (role == 'SuperAdmin') {
            items.push({ id: 'vendorType', label: 'Vendor Types', to: '/vendorType' });
            items.push({ id: 'wages', label: 'Wages Limit', to: '/Wages' });
        }

        items.push({
            id: 'reports',
            intlId: 'sidebar.accoutantant.report',
            children: [
                { id: 'fcs', intlId: 'sidebar.accoutantant.report.fcs', to: '/ACCFCK' },
                { id: 'earc', intlId: 'sidebar.accoutantant.report.earc', to: '/EARC' },
                { id: 'bsa', intlId: 'sidebar.accoutantant.report.bsa', to: '/BSA' },
                { id: 'ap', intlId: 'sidebar.accoutantant.report.ap', to: '/AP' },
                { id: 'tl', intlId: 'sidebar.accoutantant.report.tl', to: '/TL' },
                { id: 'ltl', intlId: 'sidebar.accoutantant.report.ltl', to: '/LTL' },
                { id: 'obsa', intlId: 'sidebar.accoutantant.report.obsa', to: '/OBSA' },
                { id: 'rbsn', intlId: 'sidebar.accoutantant.report.rbsn', to: '/RBSN' },
                { id: 'spl', intlId: 'sidebar.accoutantant.report.spl', to: '/SPL' },
                { id: 'cti', intlId: 'sidebar.accoutantant.report.cti', to: '/CTI' }
            ]
        });

        return items;
    }

    if (show == true) {
        const items = [
            { id: 'home', label: 'Home', to: '/dashboard' },
            {
                id: 'compliance',
                intlId: 'sidebar.accoutant',
                children: [
                    { id: 'ledgers', intlId: 'sidebar.accoutant.ledger', to: '/ledgers' },
                    { id: 'balancesheet', intlId: 'sidebar.accoutant.balancesheet', to: '/trialBalanceReview' },
                    { id: 'incomeStatement', intlId: 'sidebar.accoutant.incomeStatement', to: '/incomeStatementReview' },
                    { id: 'review', intlId: 'sidebar.accoutant.review', to: '/accoutantReview' },
                    { id: 'distribution', intlId: 'sidebar.accoutant.distribution', to: '/distributionReview' },
                    { id: 'status1099', intlId: 'sidebar.accoutant.Status1099', to: '/Status1099' },
                    { id: 'wagesComputations', intlId: 'sidebar.accoutant.wagesComputations', to: '/taxableWagesComputations' },
                    { id: 'reconciliation', intlId: 'sidebar.accoutant.reconciliation', to: '/accountreconcilliation' },
                    { id: 'payrollTax', intlId: 'sidebar.accoutant.PayrollTaxComputations', to: '/ACPYTC' }
                ]
            }
        ];

        if (role == 'SuperAdmin' || role == 'Admin') {
            items.push({
                id: 'admin',
                intlId: 'sidebar.admin',
                children: [
                    { id: 'quickbooks', label: 'QuickBooks Data Sync', to: '/QuickBooks' },
                    { id: 'companyDetail', intlId: 'sidebar.admin.company', to: '/companyDetail' },
                    { id: 'chart', intlId: 'sidebar.admin.chart', to: '/chartAccounts' },
                    { id: 'vendor', intlId: 'sidebar.admin.vendor', to: '/vendor' },
                    { id: 'lease', intlId: 'sidebar.admin.lease', to: '/leases' },
                    { id: 'loan', intlId: 'sidebar.admin.loan', to: '/loans' },
                    { id: 'employees', label: 'Employees', to: '/employees' },
                    { id: 'insurance', intlId: 'sidebar.admin.insurance', to: '/insurancePolicies' },
                    { id: 'retirement', label: 'Retirement Plan', to: '/retirementPlan' },
                    { id: 'contact', label: 'Contact', to: `/users/${companyId}` }
                ]
            });
        }

        return items;
    }

    return [];
}
